import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import _ from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
var namespace = 'calendars-store';
export default {
  store: store,
  mounted: function mounted() {
    this.getCalendarList();
  },
  computed: _objectSpread({}, mapState(namespace, ['date']), {}, mapGetters('app', ['h']), {}, mapGetters(namespace, ['calendar']), {
    // 二十四節気データおよび該当節気を準備
    season24: function season24() {
      return {
        date: this.date,
        seasons: this.calendar,
        season: _.find(this.calendar, function (i) {
          return i.belong === true;
        })
      };
    }
  }),
  methods: _objectSpread({}, mapActions(namespace, ['getCalendarList']), {
    dateSplit: function dateSplit(date) {
      return date.split('-');
    }
  })
};